import React from "react";
import ServicesBox from "./ServicesBox";
import { useAuth } from "../../Store/AuthContext";
import { ServiceLimitFetchData } from "../../APIS/FetchAPIs";

export default function ServiceSectionHome() {
  const { RendomTokenfetch } = useAuth();
  const [ServiceData] = ServiceLimitFetchData(RendomTokenfetch);

  return (
    <>
      <section
        className="featured section-padding"
        style={{ backgroundImage: `url('images/propertie-bg.jpg')` }}
      >
        <div className="container">
          <div className="row section-title">
            <div className="col col-md-8 col-md-offset-2">
              <h2>One Stop Services for SMEs</h2>
              <p>
                We are a well-known chartered accounting firm in Kuala Lumpur
                and Selangor that offers one-stop financial report compliance
                services. We are also one of the licenced secretarial firms
                registered with the Chartered Secretaries Malaysia (MAICSA).
                This allows companies (e.g. Sdn. Bhd.) registered in Malaysia to
                hire us as their company secretary to help them comply with
                Malaysian statutory requirements. We Serve The Best Services.
              </p>
            </div>
          </div>
          <div className="row content">
            {ServiceData.length > 0
              ? ServiceData.map((service, index) => (
                  <ServicesBox key={index} SerData={service} />
                ))
              : ""}
          </div>
        </div>
      </section>
    </>
  );
}
